import { type ComponentPropsWithRef } from "react";

import { type InputAlertsProps } from "../InputAlerts";

export type AlertAssociationProps = Pick<
  ComponentPropsWithRef<"input">,
  "aria-invalid" | "aria-describedby"
>;

type HasAriaDescribedByAndAlertProps = Pick<
  ComponentPropsWithRef<"input">,
  "aria-describedby"
> & {
  alertProps?: InputAlertsProps["alerts"][number] | InputAlertsProps["alerts"];
};

const buildSafeIdList = (...args: (string | undefined)[]) =>
  args.filter((arg) => arg).join(" ") || undefined;

export const buildAlertAssociationProps = (
  alertId: string,
  props: HasAriaDescribedByAndAlertProps,
  additionalAriaDescribedById?: string
): AlertAssociationProps => {
  const isInvalid = Array.isArray(props.alertProps)
    ? props.alertProps?.some((alert) => alert.severity === "error")
    : props.alertProps?.severity === "error";
  const safeAlertID = props.alertProps && alertId;
  const originalAriaDescribedByID = props["aria-describedby"];

  return {
    "aria-describedby": buildSafeIdList(
      safeAlertID,
      originalAriaDescribedByID,
      additionalAriaDescribedById
    ),
    "aria-invalid": isInvalid ? ("true" as "true") : undefined,
  };
};
